<template>
    <div>
        <v-app-bar dense class="resaltar" app>
            <v-btn icon color="black" @click="menu_principal">
                <v-icon>mdi-home</v-icon>
            </v-btn>
            
            <!-- <v-app-bar-nav-icon color="black" app></v-app-bar-nav-icon> -->

            <v-toolbar-title class="black--text">{{titulo}}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon color="black" @click="salir">
                <v-icon>mdi-power</v-icon>
            </v-btn>
        </v-app-bar>
    </div>
</template>


<script>
export default {
    name: 'BarraAplicacion',
    props:{
        titulo: String
    },
    data() {
        return {
          
        }
    },
    methods: {
        salir: function(){
            this.$router.push({ name: 'Logout' });
        },
        menu_principal(){
            let  current_path = this.$router.history.current.name
            if(current_path != 'MenuPrincipal')
                this.$router.push({name: 'MenuPrincipal'})
        }
    },
}
</script>